module.exports = __webpack_public_path__ + "images/new-products-bg-49ec5c65e3a5318114a9cc3325642228.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/new-products-bg.svg
 ** module id = 403
 ** module chunks = 0
 **/